// data for the portfolio cards

const myData = [
    {
      id: 1,
      name: "Hairy Styles",
      image:"https://hairy-styles.herokuapp.com/images/logo-3.png",
      text: "2nd Group Project - built a full stack application that allows users to search for the hair style that they are looking for - Using node.js, express JS, Sequelize, MySQL & handlebars for HTML rendering.",
      gitHub: "https://github.com/enigmawoman/Hairy-Styles",
      deployLink: "https://hairy-styles.herokuapp.com/"
    },
    {
      id: 2,
      name: "What's On Where",
      image:"https://enigmawoman.github.io/Whats-On-Where/assets/images/WOW-logo.png",
      text: "First group project - produced an online event search application, using the ticketmaster API and google maps API to display events in the chosen location.",
      gitHub: "https://github.com/enigmawoman/Whats-On-Where",
      deployLink: "https://enigmawoman.github.io/Whats-On-Where/"
    },
    {
      id: 3,
      name: "UK Weather Dashboard",
      image:"https://github.com/enigmawoman/06-Server-Side-APIs/raw/main/assets/images/Weather-dashboard.png",
      text: "Using the Open Weather Map API, I built a UK weather dashboard to display current and 5 day weather for the users location of choice.",
      gitHub: "https://github.com/enigmawoman/06-Server-Side-APIs",
      deployLink: "https://enigmawoman.github.io/06-Server-Side-APIs/"
    },
    {
      id: 4,
      name: "Windows XP ",
      image:"https://github.com/enigmawoman/Windows-XP-memories/raw/main/assets/images/windows-xp.png",
      text: "Recreation of the Windows XP login, start up and desktop - personal project to help develop my CSS skills - entire desktop is designed in CSS.",
      gitHub: "https://github.com/enigmawoman/Windows-XP-memories",
      deployLink: "https://enigmawoman.github.io/Windows-XP-memories/"
    },
    {
      id: 5,
      name: "Online Coding Quiz",
      image:"https://github.com/enigmawoman/04-Web-APIs/raw/main/assets/images/screenshotQuiz.png",
      text: "Online coding quiz to develop basic JavaScript programming skills and front end web development.",
      gitHub: "https://github.com/enigmawoman/04-Web-APIs",
      deployLink: "https://enigmawoman.github.io/04-Web-APIs/"
    },
    {
      id: 6,
      name: "Tech Blog",
      image:"https://github.com/enigmawoman/14-MVC-TechBlog/raw/main/assets/images/localhost_3001.png",
      text: "Using the MVC paradigm to produce a tech blog using Node.js, express.js, mySQL, Sequelize and Handlebars.js.",
      gitHub: "https://github.com/enigmawoman/14-MVC-TechBlog",
      deployLink: "https://protected-hollows-97045.herokuapp.com/"
    },
    {
        id: 7,
        name: "PWA Text editor",
        image:"https://pwa-jate-enigmawoman-19.herokuapp.com/assets/icons/icon_96x96.png",
        text: "First Progressive Web application development.",
        gitHub: "https://github.com/enigmawoman/19-ProgressiveWebApplications-PWA-Text-Editor",
        deployLink: "https://pwa-jate-enigmawoman-19.herokuapp.com/"
      }
  ];

 export default myData